/* eslint-disable max-len */
import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { growlErrors, growlActionSuccess } from '../../../utils/NotificationUtil';
import { resetStatusAndUpdateSuperLinkAssessmentsExpirationTime } from '../../../services/apps/SuperLinkService';
import { NotificationContext } from '../../../components/GrowlNotifications';
import SuperLinkAssessmentsExpirationUpdateForm from './SuperLinkAssessmentsExpirationUpdateForm';
import { AccountContext } from '../../../components/AccountContext';

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
  header: {
    id: 'superlink.assessments.expiration.reset.header',
    defaultMessage: 'Reset Expiration Status',
  },
  infoMessage: {
    id: 'superlink.assessments.reset.infoMessage',
    defaultMessage:
      "All assessments' status will be set to the one they had before expiring (NEW, INVITED, STARTED), and will have their expiration date updated with the one provided below.",
  },
});

const SuperLinkAssessmentsResetStatusExpirationUpdate = ({ superLink, toggleEdit }) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { formatMessage } = useIntl();

  const resetStatusAndUpdateExpirationTime = async (formValues) => {
    const { expirationTime } = formValues;

    const expirationTimeWithNoTimeZone = new Date(
      Date.UTC(expirationTime.getFullYear(), expirationTime.getMonth(), expirationTime.getDate()),
    );

    const input = {
      accountId: currentAccount,
      superLinkId: superLink.id,
      expirationTime: expirationTimeWithNoTimeZone,
    };
    try {
      await resetStatusAndUpdateSuperLinkAssessmentsExpirationTime(input);
      growlActionSuccess(growl, formatMessage(messages.successNoti));
      toggleEdit('resetStatusUpdateExpiration');
    } catch (errors) {
      growlErrors(growl, errors);
    }
  };

  const handleCancel = () => {
    toggleEdit('resetStatusUpdateExpiration');
    return Promise.resolve();
  };

  return (
    <SuperLinkAssessmentsExpirationUpdateForm
      onSubmit={resetStatusAndUpdateExpirationTime}
      handleCancel={handleCancel}
    />
  );
};

SuperLinkAssessmentsResetStatusExpirationUpdate.propTypes = {
  toggleEdit: PropTypes.func.isRequired,
  superLink: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default SuperLinkAssessmentsResetStatusExpirationUpdate;
